/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Optout_Robots_CaptionInputs */

const en_bot_optout_robots_caption = /** @type {(inputs: Bot_Optout_Robots_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`robots.txt: refuse BystepBot completely`)
};

const id_bot_optout_robots_caption = /** @type {(inputs: Bot_Optout_Robots_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`robots.txt: tolak BystepBot sepenuhnya`)
};

/**
* | output |
* | --- |
* | "robots.txt: refuse BystepBot completely" |
*
* @param {Bot_Optout_Robots_CaptionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_optout_robots_caption = /** @type {((inputs?: Bot_Optout_Robots_CaptionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Optout_Robots_CaptionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_optout_robots_caption(inputs)
	return en_bot_optout_robots_caption(inputs)
});